import VueI18n from "vue-i18n";

import { FINNISH_TRANSLATIONS } from './fi';
import { SWEDISH_TRANSLATIONS } from './sv';
import { ENGLISH_TRANSLATIONS } from './en';
import Vue from "vue";

Vue.use(VueI18n);

const TRANSLATIONS = {
    fi: FINNISH_TRANSLATIONS,
    sv: SWEDISH_TRANSLATIONS,
    en: ENGLISH_TRANSLATIONS
};

const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
let locale = 'fi'
if (urlParams.has('lang')) {
    locale = urlParams.get('lang')
} else {
    const hash = window.location.hash
    const regex = /lang=(\w\w)/
    let match = regex.exec(hash)
    if (match !== null) {
        locale = match[1]
    }
}

export const i18n = new VueI18n({
    locale: locale,
    messages: TRANSLATIONS,
});
